// extracted by mini-css-extract-plugin
export var displayNone = "_qq-6";
export var imgContainer = "_qq-2";
export var overflowHidden = "_qq-3";
export var productInfoCardButtonContainer = "_qq-5";
export var productTitleText = "_qq-4";
export var rightArrow = "_qq-1";
export var rightArrowContainer = "_qq-0";